import BuyerItem from "./BuyerItem";
import { useQuery } from "@tanstack/react-query";
import { GQLOffers, GQLTextBlocks } from "@gql/types/gql";
import Button from "../form/button";
import { translate } from "@helpers/translationObjectFormatter";
import {
    AccordionData,
    ICategoryByIdPageProps,
    TranslationsObject,
} from "@genericTypes/sharedTypes";

import { useMemo, useState } from "react";
import Accordion from "../newAccordion";
import { titleDecoder } from "@lib/sharedUtils";
import { Session } from "src/api/session";

const BUYERS_BY_PAGE = 10;
export default function BestBuyers({
    buyers,
    categoryId,
}: {
    buyers: GQLOffers[];
    categoryId: number;
}) {
    const [limit, setLimit] = useState(BUYERS_BY_PAGE);
    const { data: session } = useQuery<Session>(["session"]);
    const { data: props } = useQuery<ICategoryByIdPageProps>([
        "categoryPageProps",
    ]);
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const {
        category: categoryById,
        offersListTextBlock: textBlock,
        categoryFAQs: faqs,
    } = props ?? {};

    const offersToShow = useMemo(() => {
        return buyers?.slice(0, limit);
    }, [buyers, limit]);

    return (
        <section className="">
            {textBlock ? (
                <h2
                    id="best"
                    className="font-extrabold  lg:leading-[45px] leading-7 lg:text-3xl text-xl mt-12 lg:mb-10 mb-7"
                    dangerouslySetInnerHTML={{
                        __html: titleDecoder(
                            ((textBlock as GQLTextBlocks)?.text as string) ??
                                "",
                            {
                                category: (categoryById?.name as string) ?? "",
                                region: session?.visitDetails?.region,
                            },
                        ),
                    }}
                ></h2>
            ) : (
                <h2
                    id="best"
                    className="font-extrabold  lg:leading-[45px] leading-7 lg:text-3xl text-xl mt-12 lg:mb-10 mb-7"
                >{`${translate(
                    translations,
                    "several_categoryPage_checkBestCompanies",
                )} ${
                    (categoryById?.label as string) ??
                    (categoryById?.name as string)
                }`}</h2>
            )}
            <div>
                {offersToShow?.map((buyer, index) => (
                    <BuyerItem
                        key={index}
                        buyer={buyer}
                        index={index}
                        categoryId={categoryId}
                    />
                ))}
                {buyers.length <= BUYERS_BY_PAGE ? (
                    <></>
                ) : offersToShow.length >= buyers.length ? (
                    <></>
                ) : (
                    <div className="sm:w-[30%] w-[80%] mx-auto">
                        <Button
                            onClick={() => {
                                setLimit((prev) => prev + BUYERS_BY_PAGE);
                            }}
                            disabled={offersToShow.length >= buyers.length}
                            className="py-3"
                        >
                            {translate(translations, "several_general_seeMore")}
                        </Button>
                    </div>
                )}
                {(faqs?.length ?? 0) > 0 && (
                    <div className="my-10">
                        <Accordion
                            title={"FAQs"}
                            data={faqs as AccordionData[]}
                        />
                    </div>
                )}
            </div>
        </section>
    );
}
